export class InfoConcat{
    id?:string;
    name:string;
    email:string;
    nameCompany:string;
    message:string;
    frecuency:{id:string, name:string};
    createdAt:any;
    deleted:boolean;
}